export default __webpack_public_path__ + "static/whitepaper_newbg_mobile-a13419ff71943fde45dcc496ecb04783.jpg";